/* ----------------- UI Components --------------- */
import { Box, Loader, StickyButtonContainer } from "@memorang/ui";
import ChangAvatarView from "../components/ChangeAvatarView";

/* ----------------- Custom Hooks --------------- */
import { useAvatars } from "../hooks/useAvatars";

const ChangeAvatarRouteContainer = () => {
	const {
		avatars,
		setSelectedAvatarId,
		selectedAvatarId,
		isUpdatingAvatar,
		handleUpdateAvatar,
	} = useAvatars();

	if (!avatars?.length) {
		return (
			<Box flex={1}>
				<Loader />
			</Box>
		);
	}

	return (
		<StickyButtonContainer
			buttonText={"Change Avatar"}
			onPress={handleUpdateAvatar}
			disabled={isUpdatingAvatar || !selectedAvatarId}
			loading={isUpdatingAvatar}
		>
			<ChangAvatarView
				avatars={avatars}
				handleSelectAvatar={(id) => setSelectedAvatarId(id)}
				selectedAvatarId={selectedAvatarId}
			/>
		</StickyButtonContainer>
	);
};

export default ChangeAvatarRouteContainer;
